import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const base = css`
  display: flex;
  flex-wrap: wrap;
`

const item = ({ theme }) => css`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  transition: opacity 0.2s ease-in-out;
  width: ${rem(204)};

  &:before {
    content: '';
    width: ${rem(8)};
    height: ${rem(8)};
    border-radius: 50%;
    background-color: ${theme.color.primary.positive};
    margin-right: ${rem(8)};
  }
`

export const styles = { base, item }
